<template>
    <div class="card">
        <div class="card-header bg-secondary d-flex justify-content-between" v-if="abonoCopy.asiento">
            <div>
                <span>{{ n_abono }} <br/></span>
                <template v-if="abonoCopy.plaza && Object.keys(abonoCopy.plaza).length">
                    <span v-if="abonoCopy.plaza.region_name">{{ abonoCopy.plaza.region_name }} <br/></span>
                    <template v-if="abonoCopy.plaza.fila && abonoCopy.plaza.butaca">
                        Fila: {{ abonoCopy.plaza.fila }} / Butaca: {{ abonoCopy.plaza.butaca }}
                    </template>
                    <template v-else>
                        Plaza: {{ abonoCopy.plaza.numero }}
                    </template>
                    <span v-if="abonoCopy.plaza.visibilidad_reducida || abonoCopy.plaza.porcentaje_visibilidad">
                        &nbsp;-&nbsp;
                    </span>
                    <span v-if="abonoCopy.plaza.visibilidad_reducida" class="text-danger">
                        {{ $t('visibilidad_reducida.nombre') }}
                    </span>
                    <span v-if="abonoCopy.plaza.porcentaje_visibilidad" class="text-danger">
                        : {{ abonoCopy.plaza.porcentaje_visibilidad }}%
                    </span>
                </template>
                <template v-else-if="abonoCopy.asiento">
                    {{ abonoCopy.asiento.zona_nombre }} <br/>
                    Fila: {{ abonoCopy.asiento.fila }} / Butaca: {{ abonoCopy.asiento.asiento }}
                    <span v-if="abonoCopy.asiento.visibilidad_reducida || abonoCopy.asiento.porcentaje_visibilidad">
                        &nbsp;-&nbsp;
                    </span>
                    <span v-if="abonoCopy.asiento.visibilidad_reducida" class="text-danger">
                        {{ $t('visibilidad_reducida.nombre') }}
                    </span>
                    <span v-if="abonoCopy.asiento.porcentaje_visibilidad" class="text-danger">
                        : {{ abonoCopy.asiento.porcentaje_visibilidad }}%
                    </span>
                </template>
            </div>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-header bg-secondary d-flex justify-content-between" v-else-if="abonoCopy.plaza">
            <div>
                <span>{{ n_abono }}. </span>
                {{ abonoCopy.plaza.plazaName }}
            </div>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-header bg-secondary d-flex" v-else>
            <span>Abono - {{ n_abono }}</span>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-body">
            <label for="obtener">Obtener datos de abonado existente</label>
            <div class="input-group">
                <input name="obtener" type="text" class="form-control" placeholder="Introduce nº de abonado" v-model="buscar"/>
                <span class="input-group-append">
                    <Button @click.prevent="buscarAbonado()" type="button" class="btn-flat" :disabled="desactivar">Obtener</Button>
                </span>
            </div>
            <hr/>
            <template v-if="!loading">
                <div class="form-group">
                    <label for="nombre">Nombre</label>
                    <ValidationProvider :name="'nombre' + index" rules="required" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="text"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="Nombre"
                            v-model="abonoCopy.nombre"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="apellidos">Apellidos</label>
                    <ValidationProvider :name="'apellidos' + index" rules="required" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="text"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="Apellidos"
                            v-model="abonoCopy.apellidos"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <label for="genero">Género</label>
                    <ValidationProvider :name="'generos' + index" rules="required" v-slot="{ errors }">
                        <select
                            :disabled="desactivar"
                            :id="'genero' + index"
                            name="genero"
                            v-model="abonoCopy.genero_id"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            @change="actualizado"
                        >
                            <option
                                v-for="(genero, index) in generos"
                                :key="index"
                                :value="genero.id"
                            >
                                {{ genero.name }}
                            </option>
                            <template >
                            </template>
                        </select>
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <DocumentoTipo
                        v-model="abonoCopy.tipoDocumento"
                        :index="parseInt(index)"
                        :disabled="desactivar"
                    />
                </div>

                <div class="form-group">
                    <DocumentoValor
                        v-model="abonoCopy.dni"
                        :type="abonoCopy.tipoDocumento"
                        :index="parseInt(index)"
                        :disabled="desactivar"
                        @input="debouncedActualizado"
                    />
                </div>
                <DateInput
                    label="Fecha de nacimiento"
                    :name="'fecha_nacimiento' + index"
                    :id="'fecha_nacimiento' + index"
                    min="1900-01-01"
                    max="9999-12-31"
                    v-model="abonoCopy.fecha_nacimiento"
                    :disabled="desactivar"
                    :data-cy="'fecha_nacimiento' + index"
                    @change="actualizado"
                    wrapper-class="form-group"
                />
                <div class="form-group">
                    <label for="email">Email</label>
                    <ValidationProvider :name="'email' + index" rules="required|email" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="email"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="Email"
                            v-model="abonoCopy.email"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>
                <div class="form-group mb-4">
                    <label for="telefono">Teléfono</label>
                    <PhoneInput
                        :name="'telefono' + index"
                        :phone="abonoCopy.telefono ?? null"
                        :desactivar="desactivar"
                        :required="true"
                        @setNumber="(number) => abonoCopy.telefono = number"
                        @validNumber="(valid) => handleValidNumber(valid)"
                    />
                </div>
                <div v-if="mostrar_iban == true" class="form-group">
                    <label for="iban">IBAN</label>
                    <ValidationProvider :name="'iban' + index" rules="required" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="text"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="IBAN"
                            v-model="abonoCopy.iban"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>
                <div v-if="mostrar_titular_cuenta == true" class="form-group">
                    <label for="titular_cuenta">Titular de la cuenta</label>
                    <ValidationProvider :name="'titular_cuenta' + index" rules="required" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="text"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="Titular de la cuenta"
                            v-model="abonoCopy.titular_cuenta"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <Paises
                        :desactivar="desactivar"
                        :errors="errors"
                        @rellenarPais="rellenarPais"
                        @selected="opt => { pais = opt; abonoCopy.pais = opt.nombre; if (opt.nombre !== 'España') { provincia = null; abonoCopy.provincia = ''; abonoCopy.localidad = ''; } actualizado(); }"
                    />
                </div>
                <div class="form-group" v-if="isSpain">
                    <Provincias
                        :desactivar="desactivar"
                        :errors="errors"
                        :pais="pais.id"
                        :provincia="abonoCopy.provincia"
                        @selected="opt => { provincia = opt; abonoCopy.provincia = opt.nombre; actualizado(); }"
                    />
                </div>
                <div class="form-group" v-if="isSpain">
                    <Locations
                        :desactivar="desactivar"
                        :localidad="abonoCopy.localidad ?? ''"
                        :provincia="provincia"
                        :errors="errors"
                        :forceMultiselect="true"
                        @selected="opt => { abonoCopy.localidad = opt.nombre; actualizado(); }"
                    />
                </div>
                <div class="form-group">
                    <label for="domicilio">Domicilio completo</label>
                    <ValidationProvider :name="'domicilio' + index" rules="required" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="text"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            placeholder="Domicilio"
                            v-model="abonoCopy.domicilio"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="cp">CP/ZIP CODE</label>
                    <ValidationProvider :name="'cp' + index" rules="numeric" v-slot="{ errors }">
                        <input
                            :disabled="desactivar"
                            type="number"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            maxlength="5"
                            minlength="5"
                            placeholder="CP/ZIP CODE"
                            v-model="abonoCopy.cp"
                            @change="actualizado"
                        />
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="peña">Peña</label>
                    <input
                        :disabled="desactivar"
                        type="text"
                        class="form-control"
                        placeholder="Peña"
                        v-model="abonoCopy.penista"
                        @change="actualizado"
                    />
                </div>
                <div class="form-group">
                    <label for="empresa">Empresa</label>
                    <input
                        :disabled="desactivar"
                        type="text"
                        class="form-control"
                        placeholder="Empresa"
                        v-model="abonoCopy.empresa"
                        @change="actualizado"
                    />
                </div>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" class="form-group">
                        <FieldComponent
                            :field="field"
                            :desactivar="desactivar"
                            v-model="abonoCopy.properties[field.name]"
                        />
                    </div>
                </template>
                <div class="form-group">
                    <label for="area">Tipo de abono</label>
                    <ValidationProvider :name="'area' + index" rules="required" v-slot="{ errors }">
                        <select
                            :disabled="desactivar"
                            id="tipo-abono"
                            name="area"
                            v-model="abonoCopy.area"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            @change="actualizado"
                        >
                            <option
                                v-if="getPrecioAbono(abonoCopy) && getPrecioAbono(abonoCopy).length == 0"
                                :value="null"
                                disabled
                            >
                                No hay tipos de abono disponibles
                            </option>
                            <option
                                v-for="(precio, index) in getPrecioAbono(abonoCopy)"
                                :key="index"
                                :value="precio"
                            >
                                <span v-if="precio.renovacion">(Renovación) - </span>
                                {{ precio.descripcion }}
                            </option>
                            <template>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>

                <div class="form-group" v-if="abonoCopy.area && abonoCopy.area.descuentos && abonoCopy.area.descuentos.length > 0">
                    <label for="precio">Precio</label>
                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                        <select
                            :disabled="desactivar"
                            id="precio"
                            name="precio"
                            v-model="abonoCopy.precio"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            @change="actualizado"
                        >
                            <option
                                v-for="(descuento, index) in preciosAbonoFiltrados"
                                :key="index"
                                :value="descuento"
                            >
                                {{ descuento.label_taquilla ?? descuento.descripcion }}
                            </option>
                            <template>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>
                <template v-if="permisos['venta.descuento']">
                    <DescuentoComponent :data="abonoCopy" :index="index" :desactivar="desactivar" :importe="abonoCopy.precio ? abonoCopy.precio.precio : 0"/>
                </template>
                <div class="form-group">
                    <label for="observaciones">Observaciones</label>
                    <textarea
                        :disabled="desactivar"
                        class="form-control"
                        rows="3"
                        placeholder="Observaciones..."
                        v-model="abonoCopy.observaciones"
                        @change="actualizado"
                    ></textarea>
                </div>

                <div class="form-group mt-3" v-if="lista_abonados.renovacion_automatica">
                    <div class="checkbox-container py-2">
                        <input
                            type="checkbox"
                            :name="'renovacion-automatica-' + index"
                            :id="'renovacion-automatica-' + index"
                            :disabled="desactivar"
                        />
                        <label :for="'enviar_whatsapp' + index">Enviar por WhatsApp</label>
                    </div>
                </div>

                <div v-if="lista_abonados.renovacion_automatica" class="pb-1">
                    <checkBoxRenovacion
                        v-model="abonoCopy.renovacion_automatica"
                        :identificador="index"
                    />
                </div>

                <hr/>

                <div class="form-group">
                    <DatosLegales :index="index" :abono="abonoCopy" :font_size="'16'" :text_align="'left'" :disabled="desactivar"/>
                </div>
            </template>
            <template v-else>
                <LoaderComponent/>
            </template>
        </div>
    </div>
</template>

<script>
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import Paises from "../../../common/forms/Paises";
    import FieldComponent from '@/components/common/FieldComponent';
    import DatosLegales from '@/components/backend/abonados/DatosLegales.vue';
    import DescuentoComponent from "../../components/DescuentoComponent.vue";
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import checkBoxRenovacion from '@/components/common/checkBoxRenovacion.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';
    import DateInput from "@/modules/ui/DateInput.vue";
    import { esDescuentoValidoParaEdad } from '@/composables/common/useFiltrarDescuentosPorEdad';
    import { TEATRO_HASH_GIMNASTICA_SEGOVIANA } from '@/constants/teatros';

    export default {
        props: ['abono', 'generos', 'index', 'precios', 'area', 'zona', 'desactivar', 'validator'],
        data() {
            return {
                buscar: '',
                loading: false,
                errors: [],
                provincia: null,
                pais: null,
                mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
                mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta,
                abonoCopy: this.abono
            }
        },
        created() {
            this.debouncedActualizado = _.debounce(this.actualizado, 1000);

            this.abonoCopy.privacidad = true;
            this.abonoCopy.condiciones = true;
            this.abonoCopy.comunicaciones = true;

            if (!this.abonoCopy.telefono) {
                this.$set(this.abonoCopy, 'telefono', '');
            }

            if (!this.abonoCopy.tipoDocumento) {
                this.$set(this.abonoCopy, 'tipoDocumento', 'DNI');
            }

            this.abonoCopy.descuento_aplicado = 0;
            this.abonoCopy.descuento_integro = 0;
            if (this.precios && this.precios.length == 1) {
                this.abonoCopy.area = this.precios[0];
                if (this.abonoCopy.area.descuentos && this.abonoCopy.area.descuentos.length == 1) {
                    this.abonoCopy.precio = this.abonoCopy.area.descuentos[0]
                    if (this.abonoCopy.area.activar_pago_plazos) {
                        this.abonoCopy.area.descuentos[0].activar_pago_plazos = this.abonoCopy.area.activar_pago_plazos;
                        this.abonoCopy.area.descuentos[0].min_cantidad_plazos =  this.abonoCopy.area.min_cantidad_plazos;
                        this.abonoCopy.area.descuentos[0].max_cantidad_plazos = this.abonoCopy.area.max_cantidad_plazos;
                        this.abonoCopy.area.descuentos[0].frecuencias = this.abonoCopy.area.frecuencias[0]

                        this.abonoCopy.precio = this.abonoCopy.area.descuentos[0]
                    }
                }
            }

            if (this.teatro.provincia) {
                this.abonoCopy.provincia = this.teatro.provincia.nombre;

            }

            this.abonoCopy.properties = {};

            if(this.$route.query.n_abonado_antiguo && this.n_abono == 1) {
                this.buscar = this.$route.query.n_abonado_antiguo;
                this.buscarAbonado();
            }

            if (this.precios) {
                if(!this.abonoCopy.area) {
                    this.abonoCopy.area = this.precios[0];
                }
                this.precios.forEach(precio => {
                    if(this.zona && precio.descripcion.toUpperCase() === this.zona.name.toUpperCase()) {
                        this.abonoCopy.area = precio;
                    }
                });
            }

            this.actualizado();
        },
        watch:{
            abono(newAbono) {
                if (!this.abonoCopy || !newAbono) return;
                const currentArea = this.abonoCopy.area;
                const currentPrecio = this.abonoCopy.precio;
                Object.assign(this.abonoCopy, newAbono);
                if (currentArea) this.abonoCopy.area = currentArea;
                if (currentPrecio) this.abonoCopy.precio = currentPrecio;
            },
            provincia(newVal, oldVal) {
                if (oldVal && newVal && oldVal.id !== newVal.id) {
                    this.abonoCopy.localidad = '';
                }
            },
            'abonoCopy.area': function(newArea) {
                if (!this.abonoCopy.precio) return;
                const descuentos = newArea?.descuentos || [];
                const pertenece = descuentos.some(d => d.id === this.abonoCopy.precio.id);
                if (!pertenece) {
                    this.$set(this.abonoCopy, 'precio', null);
                }
            },
        },
        computed: {
            sinFiltroEdad() {
                return this.$store.getters.getConfig?.hash_teatro === TEATRO_HASH_GIMNASTICA_SEGOVIANA;
            },
            n_abono() {
                return parseInt(this.index) + 1;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista_id() {
                return this.$store.getters.getListaId;
            },
            fields() {
                return this.$store.getters.getListaAbonados.fields;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            isSpain() {
                return this.pais && this.pais.nombre === 'España';
            },
            preciosAbonoFiltrados() {
                const descuentos = this.abonoCopy.area ? this.abonoCopy.area.descuentos : [];
                if (this.sinFiltroEdad) return descuentos;

                const fecha = this.abonoCopy.fecha_nacimiento;
                if (!fecha) return descuentos;
                return descuentos.filter(d => esDescuentoValidoParaEdad(d, fecha));
            },
        },
        methods: {
            getPrecioAbono(abono){
                const fecha = this.abonoCopy.fecha_nacimiento;
                const filtrarPorEdad = precios => {
                    if (this.sinFiltroEdad || !fecha || !precios) return precios;
                    return precios.filter(p =>
                        p.descuentos && p.descuentos.some(d => esDescuentoValidoParaEdad(d, fecha))
                    );
                };
                const esRenovacion = !!(abono && abono.n_abonado_antiguo) || !!this.$route.query.n_abonado_antiguo;

                if(this.precios && this.precios.length > 0) {
                    if(abono.penista) {
                        let precios_penista = this.precios.filter(precio => precio.exclusivo_penista);

                        if(precios_penista.length > 0){
                            const result = esRenovacion
                                ? precios_penista.filter(precio => precio.renovacion)
                                : precios_penista.filter(precio => !precio.renovacion);
                            return filtrarPorEdad(result);
                        }
                    }

                    const result = esRenovacion
                        ? this.precios.filter(precio => precio.renovacion && !precio.exclusivo_penista)
                        : this.precios.filter(precio => precio.descuentos.length > 0 && !precio.exclusivo_penista && !precio.renovacion);
                    return filtrarPorEdad(result);
                }

                if(abono.plaza && abono.plaza.precios && abono.plaza.precios.length > 0) {
                    const result = esRenovacion
                        ? abono.plaza.precios.filter(precio => precio.renovacion)
                        : abono.plaza.precios.filter(precio =>  precio.descuentos.length > 0 && !precio.exclusivo_penista && !precio.renovacion);
                    return filtrarPorEdad(result);
                }

                return [];
            },
            handleValidNumber(valid) {
                this.$emit('isValidNumber', { index: this.index, valid });
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    filters : {
                        n_abonado_antiguo: this.buscar,
                        n_abonado_antiguo_single: this.buscar
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.abonados.renovacion'), params).then(res => {
                    this.$nextTick(function() {
                        this.abonoCopy.nombre = res.data.data.name;
                        this.abonoCopy.apellidos = res.data.data.surnames;
                        this.abonoCopy.dni = res.data.data.dni;
                        this.abonoCopy.es_nuevo = false;
                        this.abonoCopy.telefono = res.data.data.telefono;
                        this.abonoCopy.fecha_nacimiento = res.data.data.fecha_nacimiento;
                        this.abonoCopy.email = res.data.data.email;
                        this.abonoCopy.provincia = res.data.data.provincia;
                        this.abonoCopy.localidad = res.data.data.localidad;
                        this.abonoCopy.domicilio = res.data.data.domicilio;
                        this.abonoCopy.penista = res.data.data.penista;
                        this.abonoCopy.observaciones = res.data.data.observaciones;
                        this.abonoCopy.n_abonado_antiguo = res.data.data.n_abonado_antiguo;
                        this.abonoCopy.cp = res.data.data.cp;
                        this.abonoCopy.importe_monedero = res.data.data.importe_monedero;
                        this.abonoCopy.empresa = res.data.data.empresa;
                    });

                }).finally(() => this.loading = false);
            },
            rellenarPais(pais) {
                this.pais = pais;
                this.abonoCopy.pais = pais.nombre;
                this.$emit('actualizado');
            },
            actualizado() {
                this.$emit('actualizado');
                this.$emit('setDatosAbono', this.abonoCopy, this.index);
            }
        },
        components: {
            Locations,
            Provincias,
            Paises,
            DatosLegales,
            DescuentoComponent,
            PhoneInput,
            FieldComponent,
            checkBoxRenovacion,
            DocumentoTipo,
            DocumentoValor,
            DateInput
        }
    }
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .espacio {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
    .error-message {
        font-size: 11px;
        display: block;
        background-color: #DC3545;
        color: white;
        padding: 6px;
    }
</style>
